import list from './list'
import show from './show'

export default {
  list,
  show
}
